import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=d353808e&scoped=true&"
import script from "./Default.vue?vue&type=script&lang=js&"
export * from "./Default.vue?vue&type=script&lang=js&"
import style0 from "./Default.vue?vue&type=style&index=0&id=d353808e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d353808e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Abdulrahman/Desktop/projects/frontend/ideraos_del/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
installComponents(component, {VApp,VContent,VNavigationDrawer})
